module.exports = __webpack_public_path__ + "img/jardinopolis.1674fc17.png";